import { createFileRoute } from "@tanstack/react-router";

import { VerificationPhoneLogsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/verification/phone-logs")({
  component: VerificationPhoneLogsPage,
});
